export default {
  // Accumulate 筛选器 开始
  'common_Separated': 'Separated',
  'common_Accumulated': 'Accumulated',
  'common_Dimension': 'Dimension',
  'common_by_Time': 'By Time',
  'common_by_Date': 'By Date',
  'common_by_Zone': 'By Zone',
  'common_Zone': 'Zone',
  'common_by_Region': 'By Region',
  'common_Region': 'Region',
  'common_by_Country': 'By Country',
  'common_Country': 'Country',
  'common_by_Category': 'By Product Category',
  'common_Category': 'Product Category',
  'common_by_Product': 'By Product',
  'common_Product': 'Product Name',
  'common_by_catalog': 'By Catalog',
  'common_catalog': 'Catalog',
  'common_by_System': 'By Platform',
  'common_System': 'Platform',
  'common_by_Channel': 'By Channel',
  'common_Channel': 'Channel',
  'common_by_Language': 'By Language',
  'common_Language': 'Language',
  'common_by_Bundle': 'By Bundle',
  'common_Bundle': 'Bundle',
  'common_Churn_level': 'Churn Level',
  'common_churn_level': 'Churn Level',
  'common_by_churn_level': 'By Churn Level',
  'common_by_netWork_Type': 'By Network Type',
  'common_ua_network': 'Media Channel',
  "common_campaign": 'Campaign',
  'common_by_ua_network': 'By Media Channel',
  'common_by_campaign': 'By Campaign',
  "common_ab_test": 'AB Test',
  'common_by_ab_test': 'By AB Test',
  'common_version': 'Version',
  'common_by_version': 'By Version',
  'common_ad_format': 'Ad Format',
  'common_by_ad_format': 'By Ad Format',
  'common_pv_threshold': 'Event Occur Count',
  'common_by_pv_threshold': 'By Event Occur Count',

  'common_casual_network_type': 'Media Channel Type',
  'common_by_network_type': 'By Media Channel Type',
  'common_media_source': 'Media Channel',
  'common_netWork_Type': 'Network Type',
  'common_country_top_10': 'of Top 10 Countries',
  'common_region_top_10': 'of Top 10 Regions',
  'common_newtwork_top_10': 'of Top 10 Network Type',
  'common_zone_top_10': 'of Top 10 Zones',
  'common_platfrom_top_10': 'of Platform',
  'common_language_top_10': 'of Language',
  'common_channel_top_10': 'of Top 10 Channel',

  'common_country_region_zone_breakdown': 'Country/Region/Zone Breakdown',
  'common_country_system_language_breakdown': 'Country/Platform/Language Breakdown',

  // 更多/收起
  'common_more': 'More',
  'common_close': 'Close',
  // Accumulate 筛选器 结束

  // 运算筛选器 key
  'common_Sum': 'Sum',
  'common_Avg': 'Avg',
  'common_Max': 'Max',
  'common_Min': 'Min',
  'common_Average': 'Average',
  'common_Average(remove_Null)': 'Avg(≠Null)',
  'common_Average(remove_Null&0)': 'Avg(≠Null&0)',
  'common_Count': 'Count',
  // 运算筛选器 key 结束
  'common_sum': 'Sum',
  'common_max': 'Max',
  'common_min': 'Min',
  'common_avg': 'Average',
  'common_avg_no_null': 'Avg(≠Null)',
  'common_avg_no_null_zero': 'Avg(≠Null&0)',
  'common_count': 'Count',

  // 宽表上方选择是否展示同比环比
  'common_value_only': "Value Only",
  'common_show_change': "Show Change",
  'common_show_dod_Day': "Show DoD",
  'common_show_dod_Week': "Show WoW",
  'common_show_dod_Month': "Show MoM",
  'common_show_sdlw_Day': "Show SDLW",
  'common_show_sdlw_Week': "Show SWLM",
  'common_show_sdlw_Month': "Show SMLY",

  // 表格列 标题
  'common_zone': 'Zone',
  'common_region': 'Region',
  'common_country': 'Country',
  'common_system': 'Platform',
  'common_channel': 'Channel',
  'common_language': 'Language',
  'common_bundle': 'Bundle',
  'common_app_version': 'App Version',
  'common_network_type': 'Network Type',
  'common_memory': 'Memory',
  'common_store_channel': 'Store Channel',
  'common_category': 'Product Category',
  'common_product': 'Product Name',

  // 分页
  'common_records': 'records',
  'common_share': 'Share',
  'common_discount': 'Discount',
  'common_discount_avg': 'Avg.Discount',
  'date': 'Date',
  'common_date': 'Date',
  'common_time': 'Time',
  'common_level': 'Level',
  'common_total': 'Total',
  'common_day_of_week': 'Day of week',

  // 无数据提示
  'common_nodata': 'No data under current filter selections.',
  'common_loading': 'Loading...',
  'common_loading_failed': 'Load failed.',
  'common_loading_failed_realtime': 'No data yet.',
  'common_not_found': "Search content not found",
  'common_go_back_table': 'Return to the original list',
  'common_retry_table': "Refresh Retry",
  'common_event_selector_nodata': 'No result found.',
  'common_discount_nodata': 'There is no discount information available for the currently selected country.',
  // 留存
  'common_d2': 'D2',
  'common_d3': 'D3',
  'common_d7': 'D7',

  // 指标卡片
  'today': 'Today',
  'week': 'This Week',
  'month': 'This Month',

  'card_today': 'Today',
  'card_week': 'This Week',
  'card_month': 'This Month',

  'sum': 'SUM',
  'avg': 'AVG',

  'wow': 'WoW',
  'swlm': 'SWLM',
  'dod': 'DoD',
  'sdlw': 'SDLW',
  'mom': 'MoM',
  'smly': 'SMLY',
  'change': 'Change',
  'contrast day': 'Contrast Day',
  'common_today': 'Today',
  'common_yesterday': 'Yesterday',
  'common_sdlw': 'Same Day Last Week',
  'common_data_toptip_text': 'The calculated time zone is UTC0 time zone, and the data update of the previous day is about 10:30-11:30 AM Beijing time.',
  'common_data_toptip_text_fam_jp': 'The calculated time zone is UTC9 time zone, and the data update of the previous day is about 2：00-3：00 AM Beijing time.',
  'common_down_success_text': 'Download Successfully',
  'common_down_error_text': 'Download Failed',
  'common_down_loading_text': 'Downloading',

  'common_mon': 'Mon',
  'common_tues': 'Tue',
  'common_wed': 'Wed',
  'common_thur': 'Thu',
  'common_fri': 'Fri',
  'common_sat': 'Sat',
  'common_sun': 'Sun',

  'common_others': 'Others',
  'common_contrast': 'Contrast',

  'common_day': 'day',
  'common_week': 'week',
  'common_month': 'month',

  'common_days': 'days',
  'common_weeks': 'weeks',
  'common_months': 'months',

  'common_timezone': 'Timezone',

  'common_pages': 'Page',
  'common_metrics': 'Metrics',
  'common_customized_metrics': 'Customized Metrics',
  'common_no_report_serach': 'Sorry,there is no result for this keyword',

  'common_confirm': 'Confirm',
  'common_cancel': 'Cancel',
  'common_all': 'All',
  'common_back': 'Back',
  'common_customize': 'Customize',

  'common_select_placeholder': 'Please Select',
  // 'common_select_placeholder_path': 'Please Select Path Url',
  // 'common_select_placeholder_work': 'Please Select Workbook Url',
  // 'common_select_placeholder_url': 'Please Select Url',
  // 'common_select_placeholder_datalab': 'Please Select Datalab',
  // 'common_select_placeholder_preset': 'Please Select Preset',

  'common_line_chart': 'Line Chart',
  'common_funnel_chart': 'Funnel Chart',
  'common_bar_chart': 'Bar Chart',
  'common_stack_line_chart': 'Stack Line Chart',
  'common_pie_chart': 'Pie Chart',
  'common_map_chart': 'Map Chart',
  'common_Tree': 'Tree Chart',
  'common_table': 'Table',
  'common_down_load': 'Download',
  'common_download_image': 'Save As Image',

  'common_show_values': 'Show values',
  'common_hide_values': 'Hidden values',
  'common_show_event': 'Only show start date',
  'common_hide_event': 'Show date range',
  'common_comparison_analysis': 'Comparison Analysis',
  'common_show_all': 'Show All',
  'common_show_less': 'Show Less',

  'data_tag_bubble_hidden': "Hidden values.",
  'data_tag_bubble_show': "Show values.",
  'change_tag_bubble_show': "Y = Min",
  'change_tag_bubble_hidden': "Y = 0",

  'common_search_no_data': "There's no data under the current search conditions",

  'common_select_content_download': 'Please select the content to download',

  'common_table_downloading': 'Downloading',
  'common_table_download_success': 'Download Successfully',
  'common_table_download_failed': 'Download Failed',
  'common_publish_filter_please': 'Please enter correct date',
  'common_publish_filter_date_out': 'Date out of range',
  'common_publish_filter_date_should': 'Date range should be less than 365 days',
  'common_region_market': ' Country/Market',

  'common_day_num': '{num}{suffix}',

  'common_system_admin': 'Management Platform',

  // 表单错误提示
  'form_error_message_not_empty': "{field} must be filled in.",
  'form_error_message_limit_length': "The content must contain less than {length} charts.",
  'form_error_message_empty_limit': "{field} must be filled in, and the maximum length is {length} chars",
  'form_error_message_exists': "{field} already exists, please re-enter.",

  'common_overview': "Overview",
  'common_realtime': "Realtime",

  "common_edit": 'Edit',
  "common_delete": 'Delete',

  'common_yes': "Yes",
  'common_no': "No",
  'common_setting': 'Setting',

  'common_comming': "Coming Soon",

  'common_back_to_old_link': "Goto old version",

  'common_copy_success': "Copy Successfully",
  'common_copy_fail': "Copy Failed",

  "common_copy_date_column": 'Copy this column',
  "common_copy_time_column": 'Copy this column',
  "common_copy_contrast_date_column": 'Copy this column',
  "common_asc": 'Asc',
  "common_des": 'Des',
  "common_asc_by_rate": 'Asc by rate of change',
  "common_des_by_rate": 'Des by rate of change',
  "common_default_sort": 'Default sorting',
  "common_copy_this_column": 'Copy this column',
  "common_copy_this_column_and_date": 'Copy this column and date',
  "common_copy_this_column_and_time": 'Copy this column and time',
  'common_filter_save_date_bubble_tips': 'Refresh automatically according to the latest time',
  'common_data': 'Data',
  'form_error_message_empty_30_limit': "Event name be filled in, and the maximum length is 30 chars",
  'form_error_message_empty_80_limit': "Event name be filled in, and the maximum length is 80 chars",
  'form_error_message_empty': "Event name Must be filled in",

  'common_component_update': 'The component is being updated',
  'common_common': 'Common',
  'common_event': 'Event',
  'common_search': 'Search',
  'common_event_type': 'Event Type',
  'common_event_name': 'Event Name',

  'common_woa_no_game_permission': 'You are unable to view the game data currently , please click the button below to apply for the permission.',
  'common_global_no_game_permission': 'You are unable to view the game data currently , please contact the organization manager to enable permission.',
  'common_filter_payment_type_tooltip': 'Product Payment Type',
  'dbd_over_limit_tip_prefix': 'The current query exceeds {count} records. Please',
  'dbd_over_limit_tip_link': 'download',
  'dbd_over_limit_tip_suffix': 'for full details.',

  // 异动日报下载
  'dbd_download_html': 'HTML',
  'dbd_download_pdf': 'PDF',
  'dbd_download_format': 'Format',
};
